module.exports = __webpack_public_path__ + "static/media/clock.61e06ae4.svg";